import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import Select from "../common/form/select";
import LabelAndInput from "../common/form/labelAndInput";

import { setModoTela, initForm } from "./gestorConcessionariaActions";
import { PhoneInput } from "../common/form/PhoneInput";

class GestorConcessionariaForm extends Component {
    render() {
        const readOnly = !!(this.props.excluir || this.props.visualizar);
        const CONCESSIONARIA_ENERGIA = this.props.formularioValues.id_tipo_concessionaria == 1;
        const CONCESSIONARIA_AGUA = this.props.formularioValues.id_tipo_concessionaria == 2;
        return (
            <>
                <ContentCard>
                    <Form event={this.props.handleSubmit}>
                        <Row alignCenter>
                            <Grid cols="12 12 6 6">
                                <ContentCardBody>
                                    <Row>
                                        <Field name="nome" component={LabelAndInput} label="Nome" placeholder="Informe o nome" cols="12 12 12 12" readOnly={readOnly} />
                                    </Row>
                                    <Row>
                                        <Select
                                            cols="12 12 12 12"
                                            name="id_tipo_concessionaria"
                                            options={this.props.listaTipoConcessionaria}
                                            label="Tipo de Concessionária"
                                            placeholder="Selecione o tipo de concessionária"
                                            value={this.props.formularioValues.id_tipo_concessionaria}
                                            onChange={(value) => {
                                                this.props.initForm({
                                                    ...this.props.formularioValues,
                                                    id_tipo_concessionaria: value,
                                                    id_concessionaria_energia: null,
                                                    id_concessionaria_agua: null,
                                                });
                                            }}
                                            readOnly={readOnly}
                                        />
                                    </Row>
                                    {CONCESSIONARIA_ENERGIA || CONCESSIONARIA_AGUA ? (
                                        <Row>
                                            <Select
                                                cols="12 12 12 12"
                                                name={CONCESSIONARIA_ENERGIA ? "id_concessionaria_energia" : "id_concessionaria_agua"}
                                                options={this.props[CONCESSIONARIA_ENERGIA ? "listaConcessionariaEnergiaSelect" : "listaConcessionariaAguaSelect"]}
                                                label="Concessionária"
                                                placeholder="Selecione a Concessionária"
                                                value={this.props.formularioValues[CONCESSIONARIA_ENERGIA ? "id_concessionaria_energia" : "id_concessionaria_agua"]}
                                                onChange={(value) => {
                                                    this.props.initForm({
                                                        ...this.props.formularioValues,
                                                        [CONCESSIONARIA_ENERGIA ? "id_concessionaria_energia" : "id_concessionaria_agua"]: value,
                                                    });
                                                }}
                                                readOnly={readOnly}
                                            />
                                        </Row>
                                    ) : null}
                                    <Row>
                                        <Field
                                            name="telefone"
                                            component={PhoneInput}
                                            label="Telefone"
                                            cols="12 12 12 12"
                                            readOnly={readOnly}
                                        />
                                    </Row>
                                    <Row>
                                        <Field
                                            name="email"
                                            component={LabelAndInput}
                                            label="E-mail"
                                            placeholder="Informe o e-mail"
                                            cols="12 12 12 12"
                                            readOnly={readOnly}
                                            maxLength={255}
                                        />
                                    </Row>
                                </ContentCardBody>
                            </Grid>
                        </Row>
                        <ContentCardFooter>
                            <Row alignCenter>
                                <Grid cols="6 6 4 3">
                                    {this.props.excluir ? (
                                        <Button
                                            text="Excluir"
                                            submit
                                            type={"danger"}
                                            icon={"fa fa-trash"}
                                            disabled={!this.props.usuarioLogado.acesso_gestor_concessionaria_excluir}
                                        />
                                    ) : (
                                        <Button
                                            text={"Salvar"}
                                            submit
                                            type={"success"}
                                            icon={"fa fa-check"}
                                            disabled={
                                                !(
                                                    this.props.usuarioLogado.acesso_gestor_concessionaria_adicionar || this.props.usuarioLogado.acesso_gestor_concessionaria_editar
                                                ) || this.props.visualizar
                                            }
                                        />
                                    )}
                                </Grid>
                                <Grid cols="6 6 4 3">
                                    <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => this.props.setModoTela("lista")} />
                                </Grid>
                            </Row>
                        </ContentCardFooter>
                    </Form>
                </ContentCard>
            </>
        );
    }
}

GestorConcessionariaForm = reduxForm({
    form: "gestorConcessionariaForm",
    destroyOnUnmount: false,
})(GestorConcessionariaForm);
const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("gestorConcessionariaForm")(state),
    registro: state.gestorConcessionaria.registro,
    listaConcessionariaEnergiaSelect: state.concessionaria.listaConcessionariaEnergiaSelect,
    listaConcessionariaAguaSelect: state.concessionaria.listaConcessionariaAguaSelect,
    listaTipoConcessionaria: state.concessionaria.listaTipoConcessionaria,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GestorConcessionariaForm);
